import React from 'react'

const HeaderTopbar = () => {
    return (
        <div className="topbar">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col col-lg-7 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul>
                                <li><i className="fi flaticon-009-telephone"></i>+263 789 099 315 / +263 716 501 140</li>
                                <li><i className="fi flaticon-010-email"></i>info@wtafirm.co.zw</li>
                                <li><i className="fi flaticon-011-maps-and-flags"></i> 38 Northampton Crescent, Eastlea, Harare</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopbar;